export default __webpack_public_path__ + "static/media/AngleDown.9739a84f.svg";